module.exports = __webpack_public_path__ + "media/images/flags/pl-9400273de5d060652ce7f8c43adbcf25.svg";